<template>
  <div class="shipping-block-list">
    <template v-if="currentUser">
      <template v-if="!$store.state.address.addressesLoading">
        <bounce-loader />
      </template>
      <template v-else>
        <template v-if="addresses.length">
          <address-card v-for="address in addresses" :address="address" :key="address.id" />
        </template>
        <div class="shipping-block-nothing" v-else>
          <span class="shipping-block-nothing-text"> {{ $t('No address added to you') }} </span>
        </div>
      </template>
    </template>
    <template v-else>
      <guest-address-card :address="guestAddress" />
    </template>
  </div>
</template>

<script async>
import { mapActions, mapGetters, mapState } from 'vuex';

const BounceLoader = () => import(/* webpackChunkName: "vsf-bounce-loader" */ 'theme/components/theme/blocks/Home/Preloaders/BounceLoader');
const GuestAddressCard = () => import(/* webpackChunkName: "vsf-guest-address-card" */ 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressList/GuestAddressCard.vue');
const AddressCard = () => import(/* webpackChunkName: "vsf-address-card" */ 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressList/AddressCard');

export default {
  name: 'AddressList',
  components: {
    AddressCard,
    BounceLoader,
    GuestAddressCard
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.user.current
    }),
    ...mapGetters({
      addresses: 'address/getAddressList',
      guestAddresses: 'address/getGuestAddresses'
    }),
    guestAddress () {
      return this.guestAddresses[0] || {};
    }
  },
  methods: {
    ...mapActions({
      loadAddresses: 'address/loadList',
      loadGuestAddresses: 'address/loadGuestList'
    })
  },
  beforeMount () {
    if (this.currentUser && (!this.addresses || !this.addresses.length)) {
      this.loadAddresses();
    }

    if (!this.currentUser && (!this.guestAddresses || !this.guestAddresses.length)) {
      this.loadGuestAddresses();
    }
  }
}
</script>

<style>
  .shipping-block-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 16px;
  }
</style>
